import { useMemo } from 'react'
import type { BlogCategoryNode, FlatBlogCategory } from './blogCategoryTree.utils'
import type { BlogCategoryRecord } from './types'
import { buildBlogCategoryTree, flattenBlogCategoryTree } from './blogCategoryTree.utils'

export type UseBlogCategoryTreeResult = {
  tree: BlogCategoryNode
  flat: FlatBlogCategory[]
}

export type UseBlogCategoryTreeProps = {
  categories?: BlogCategoryRecord[]
}

export const useBlogCategoryTree = ({ categories = [] }: UseBlogCategoryTreeProps = {}): UseBlogCategoryTreeResult =>
  useMemo(() => {
    const tree = buildBlogCategoryTree(categories)
    return { tree, flat: flattenBlogCategoryTree(tree) }
  }, [categories])
